import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import {
  ApplicationUserCrudClient,
  BorrowingEntityTypeEnum,
  ChargeTypeEnum,
  CofEnum,
  DeductorPayEnum,
  EPCRatingTypeEnum,
  EWS1GradeTypeEnum,
  ExitFeeChargedOnEnum,
  FileAttachment,
  FileAttachmentClient,
  FixedRateTermEnum,
  GuaranteeEnum,
  ImportProductResponse,
  InterestRateBasis,
  InterestServicedorRolledEnum,
  LegalFeeTypeEnum,
  LenderProductTypeEnum,
  LenderSubscriptionTypeEnum,
  LoanInvestmentTypeEnum,
  LoanRepaymentTypeEnum,
  LocationEnum,
  MezzLegalPercentOfWhatEnum,
  NonPhysicalValuationEnum,
  Organisation,
  OrganisationClient,
  QSChargesOfWhatEnum,
  RefurbishmentLevelEnum,
  StaticDataClient,
  ValuationFeeTypeEnum,
  ValuationMethodEnum,
  YesNoMaybe,
} from "@src/apis/ModularClient";
import { ProductFamilyEnum } from "@src/apis/ModularClient";
import { ProductTypeEnum } from "@src/apis/ModularClient";
import { RoleService } from "@js/services/RoleService";
import { ListItem, SelectListService } from "@js/services/SelectListService";
import { LenderClient, ProductClient, Lender, ApplicationUser, Product } from "@src/apis/ModularClient";
import { Expand } from "@ccq/ts-lib";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { ODataHelper } from "@js/helpers/ODataHelper";
import { IndexService } from "@js/services/IndexService";
import { EditorSettings } from "tinymce";
import { SharedDealService } from "@js/services/Deal/SharedDealService";

export class LenderController {
  canSeeMultipleLenders: boolean = false;
  selectedSection: string;

  objects: Lender[];
  selectedObject: Lender;
  tempSelectedObject: Lender;
  userSearchResults: Expand<ApplicationUser>[];
  //user: ApplicationUser;
  userName: string;
  userSelected: string;
  fetchingResults: boolean;
  showFilter: boolean;
  editLogo: boolean = false;

  selectedObjectProduct: Product;

  logoURL: string = "";

  // Upload Logos

  fileUpload: FileAttachment[];
  fileUploadPlaning: FileAttachment[];
  fileUploadTeam: FileAttachment[];
  fileUploadProperties: FileAttachment[];
  uploadingFiles: FileUploadProgressDTO[];
  renamingFile: FileAttachment;

  newLenderPopup: boolean = false;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  lenderForm: ng.IFormController;

  file: Blob;

  step: number;

  editLenderName: boolean = false;
  updateRating: boolean = false;
  updatePreferredBrokers: boolean = false;

  timestamp: Date;

  multiPartForm1: ng.IFormController;
  multiPartForm2: ng.IFormController;
  multiPartForm3: ng.IFormController;
  multiPartForm4: ng.IFormController;
  multiPartForm5: ng.IFormController;
  multiPartForm6: ng.IFormController;
  multiPartForm7: ng.IFormController;

  totalRate: number;

  //array describing form sections
  formSectionNames = [
    {
      label: "Lender Details",
      visible: true,
    },
    {
      label: "Overview",
      visible: true,
    },
    {
      label: "Location",
      visible: true,
    },
    {
      label: "Development Specs",
      visible: true,
    },
    {
      label: "Industry",
      visible: true,
    },
    {
      label: "Liabilities",
      visible: true,
    },
    {
      label: "Fees",
      visible: true,
    },
  ];

  showLenderUpload: boolean = false;
  addLenders: boolean = true;
  updateLenders: boolean = true;
  disableProducts: boolean = false;
  dataLoading: boolean = false;
  importFile: any = false;

  assignedLenderUsers: ApplicationUser[];
  selectLenderUserId: string = "";
  selectedLenderUser: ApplicationUser;
  showEditLenderUserModal: boolean = false;
  isEditLenderUser: boolean = false;
  lenderUserProductType: {}[] = [];
  isSavingLenderUser: boolean = false;

  confirmChangingLenderAdmin: boolean = false;
  confirmLenderAdminDeletion: boolean = false;
  displayMessage: string;
  deleteLenderUserClicked: boolean = false;
  lendersavemessage: string = "";
  error: string = "";
  filterType: string = "";

  showSimulatedResults = false;
  simulatedResponse: ImportProductResponse;
  productTypeOptions = [];
  productFamilyOptions = [];
  filteredProductTypeOptions = [];
  refurbLevelOptions = [];
  EPCRatingOptions = [];
  acceptableEWS1GradeTypeOptions = [];
  locationOptions = [];
  tradingEntityOptions = [];
  valuationMethodOptions = [];
  nonPhysicalValuationOptions: ListItem[] = [];
  accountManagersOptions: string[] = [];
  subscriptionTypeOptions = [];

  duplicateProductModal: boolean = false;
  productForDuplication: Product;
  duplicateProductIndex: number;
  productRef: string = "";

  organisations: Organisation[] = [];
  nonConnectOrganisations: Organisation[] = [];
  selectedBrokers: Organisation[] = [];
  isValidSelection: boolean;
  preferredPackagersText: string = "";
  modalTextChanged: boolean = false;

  portalLinkSettingChanged: boolean = false;
  currentPortalLinkSetting: boolean = false;

  showEditProductNotesAndSnapshot: boolean = false;
  editedLenderProductFamily: ProductFamilyEnum = null;

  minLastVerifiedDate: Date = new Date("Jan 01 1900");
  maxLastVerifiedDate: Date = null;
  lenderTinymceOptions: EditorSettings;

  static $inject = [
    "$routeParams",
    "$rootScope",
    "Upload",
    "$location",
    "RoleService",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "SelectListService",
    "$sce",
    "IndexService",
    "LenderClient",
    "ProductClient",
    "OrganisationClient",
    "ApplicationUserCrudClient",
    "ODataHelper",
    "StaticDataClient",
    "SharedDealService",
  ];
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $uploadservice: any,
    private $location: ng.ILocationService,
    private $roleservice: RoleService,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private selectListService: SelectListService,
    private $sce: ng.ISCEService,
    private indexService: IndexService,
    private $lenderClient: LenderClient,
    private productClient: ProductClient,
    private $organisationClient: OrganisationClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private odataHelper: ODataHelper,
    private staticDataClient: StaticDataClient,
    private sharedDealService: SharedDealService,
  ) {
    if (this.$roleservice.isBrokerOrABove()) {
      this.canSeeMultipleLenders = true;
    }

    this.getLenderRelationsAccountManager();
    this.lenderTinymceOptions = this.sharedDealService.tinymceOptions;
    this.lenderTinymceOptions.toolbar += " | link unlink | underline";
    this.lenderTinymceOptions.height = 250;

    this.$organisationClient.list().then((response) => {
      this.organisations = response;
      this.organisations.sort(function (a, b) {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      this.nonConnectOrganisations = this.organisations.filter((o) => !o.isConnectMember);
    });

    this.updateObjects();
    //init
    this.step = 1;
    this.updatetimestamp();
    this.fetchAllUsers();
    this.userName = "";
    this.showFilter = false;

    this.productTypeOptions = this.selectListService.GetProductTypeOptions();
    this.productFamilyOptions = this.selectListService.GetProductFamilyOptions();
    this.refurbLevelOptions = this.selectListService.GetRefurbishmentLevelOptions(true);
    this.EPCRatingOptions = this.selectListService.GetEPCRating();
    this.acceptableEWS1GradeTypeOptions = this.selectListService.GetEWS1GradeType();
    this.locationOptions = this.selectListService.GetLocations();
    this.tradingEntityOptions = this.selectListService.GetBorrowingEntityTypeOptions();

    this.valuationMethodOptions = this.selectListService.GetValuationMethodOptions();
    this.nonPhysicalValuationOptions = this.selectListService.GetNonPhysicalValuationOptions();
    this.subscriptionTypeOptions = this.selectListService.GetLenderSubscriptionTypeOptions();
  }

  onFileSelect(files) {
    if (files.length > 0) {
      this.fileAttachmentHelper.uploadFileAndReturnURI(files).then((result) => {
        this.selectedObject.logoURL = result.fileLocation;
        // this.$lenderservice.addUpdate(this.selectedObject);
        this.getLogoURL(this.selectedObject.logoURL);
        this.editLogo = true;
      });
    }
  }

  getLogoURL(url: string) {
    this.fileAttachmentClient.getAmazonFileAccessUri(url).then((result) => {
      this.logoURL = result;
    });
  }

  fetchAllUsers() {
    this.fetchingObject = true;

    this.odataHelper
      .getMany(this.applicationUserCrudClient, {
        filter: {
          and: [
            {
              lenderId: { eq: null },
            },
            {
              claimGroupsInApplicationUsers: {
                any: { claimGroup: { name: { eq: "Lender" } } },
              },
            },
          ],
        },
      })
      .then((response) => {
        this.userSearchResults = response;
      })
      .finally(() => {
        this.fetchingObject = false;
      });

    // this.$userClient.list(1)
    //   .then((response) => {
    //     this.userSearchResults = response;
    //   })
    //   .finally(() => {
    //     this.fetchingObject = false;
    //   });
  }

  fetchAssignedLenderUsers() {
    this.fetchingObject = true;
    this.$lenderClient
      .getUsersByLenderId(this.selectedObject.id)
      .then((response) => {
        this.assignedLenderUsers = response;
      })
      .finally(() => {
        this.fetchingObject = false;
      });
  }

  changeUser() {
    this.showFilter = !this.showFilter;
  }

  userLookupById(userId: number): string {
    const found = this.userSearchResults.find((user) => user.id === userId);

    if (found) {
      return (this.userName = found.userName);
    } else {
      return (this.userName = "");
    }
  }

  updatetimestamp(): void {
    this.timestamp = new Date();
  }
  back(): void {
    if (this.step > 0) {
      this.step--;
    }
  }

  next(): void {
    if (this.step < 7) {
      this.step++;
    }
  }
  cancel(): void {
    this.$location.path("/lenders/");
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  updateIsEnabled(product: Product, isEnabled) {
    product.isEnabled = isEnabled;
    this.productClient.addUpdateReturnOnlyID(product).then((result) => {});
  }

  selectObject(object: Lender) {
    this.selectedBrokers = [];
    this.selectedObject = object;
    this.selectedObject.bridgingFamilyAdditionalInfo = this.convertPlainTextToHtml(
      this.selectedObject.bridgingFamilyAdditionalInfo,
    );
    this.selectedObject.commercialFamilyAdditionalInfo = this.convertPlainTextToHtml(
      this.selectedObject.commercialFamilyAdditionalInfo,
    );
    this.selectedObject.developmentFinanceFamilyAdditionalInfo = this.convertPlainTextToHtml(
      this.selectedObject.developmentFinanceFamilyAdditionalInfo,
    );

    this.fetchAssignedLenderUsers();
    this.selectedSection = "details";
    this.editLenderName = false;
    this.userSelected = "";
    this.userLookupById(object.userId);
    this.preferredPackagersText = this.selectedObject.preferredPackagersText;

    if (this.selectedObject.logoURL) {
      this.getLogoURL(this.selectedObject.logoURL);
    } else {
      this.logoURL = "";
    }

    this.currentPortalLinkSetting = this.selectedObject.usePortalUrl;

    this.getPreferredOrgs();
  }

  createObject() {
    //Add new lender

    this.indexService.currentUserId.then((userId) => {
      this.selectedObject = {
        name: "",
        lenderGenericName: "",
        ratingCustomerService: null,
        ratingSpeed: null,
        ratingFlexibility: null,
        ratingUserRating: null,
        products: [],
        user: null,
        logoURL: "",
        isBank: false,
        lenderApplicationUsers: [],
        internalUrl: "",
        hasLiveMarketSearch: true,
        hasDevelopmentFinanceSearch: true,
        hasBridgingSearch: true,
        hasCommercialSearch: true,
        preferredPackagersText: "",
        isLenderReferralActive: true,
        usePortalUrl: false,
        portalUrl: "",
        portalUrlActiveDateTime: null,
        sendLenderInsightsEmail: false,
        bridgingFamilySnapshot: "",
        bridgingFamilyAdditionalInfo: "",
        commercialFamilySnapshot: "",
        commercialFamilyAdditionalInfo: "",
        developmentFinanceFamilySnapshot: "",
        developmentFinanceFamilyAdditionalInfo: "",
        isConnectLender: false,
        isConnectReferralOnly: false,
        avgResponseTimeDevFinance: null,
        avgResponseTimeBridging: null,
        avgResponseTimeCommercial: null,
        avgResponseTimeOverall: null,
        id: 0,
        userId: userId,
        isDeleted: false,
        createdDateTime: null,
        lastUpdatedDateTime: null,
        lastModifiedUser: null,
        lastModifiedUserId: null,
        createdUserId: null,
        createdUser: null,
        ownersApplicationUsers: [],
        ownersApplicationUserGroups: [],
        medianResponseTimeBridging: null,
        medianResponseTimeCommercial: null,
        medianResponseTimeDevFinance: null,
        medianResponseTimeOverall: null,
        accountManager: "",
      };
      this.editLenderName = true;
      this.currentPortalLinkSetting = false;
    });
  }

  userLookup(userSearchTerm: string) {
    if (userSearchTerm === "") {
      this.fetchAllUsers();
    } else {
      this.fetchingResults = true;
      this.odataHelper
        .getMany(this.applicationUserCrudClient, {
          filter: {
            and: [
              {
                lenderId: { eq: null },
              },
              {
                or: [
                  { firstName: { contains: userSearchTerm } },
                  { lastName: { contains: userSearchTerm } },
                  { email: { contains: userSearchTerm } },
                ],
              },
              {
                claimGroupsInApplicationUsers: {
                  any: { claimGroup: { name: { eq: "Lender" } } },
                },
              },
            ],
          },
        })
        .then((response) => {
          this.userSearchResults = response;
        })
        .finally(() => {
          this.fetchingResults = false;
        });
    }
  }

  updateLenderUser(id: number) {
    this.selectedObject.userId = id;
    this.$lenderClient
      .addUpdate(this.selectedObject)
      .then((response) => {})
      .finally(() => {
        this.showFilter = false;
        delete this.userSelected;
      });
  }

  editLender(SelectedLender: Lender) {
    this.editLenderName = true;
    this.editLogo = false;
    this.tempSelectedObject = { ...SelectedLender };
  }

  cancelLenderUpdate(SelectedLender: Lender) {
    this.selectedObject = this.tempSelectedObject;
    this.getPreferredOrgs();
    this.getLogoURL(this.selectedObject.logoURL);
    this.preferredPackagersText = this.selectedObject.preferredPackagersText;
    this.editLenderName = false;
    this.error = "";
  }

  saveLender(newLender: boolean = false) {
    if (
      this.selectedObject.usePortalUrl &&
      (this.selectedObject.portalUrl == null || this.selectedObject.portalUrl.length == 0)
    ) {
      this.editLenderName = true;
      this.error = "If portal link is enabled, please include a portal link.";
      return;
    }

    if (this.portalLinkSettingChanged) {
      if (!this.currentPortalLinkSetting && this.selectedObject.usePortalUrl) {
        this.selectedObject.portalUrlActiveDateTime = new Date();
      }
      if (this.currentPortalLinkSetting && !this.selectedObject.usePortalUrl) {
        this.selectedObject.portalUrlActiveDateTime = null;
      }
    }
    const existingSelection = this.selectedObject && this.selectedObject.id ? true : false;
    const duplicateLender = this.objects.find((x) => x.name == this.selectedObject.name);
    if ((!duplicateLender || newLender == false) && this.fetchingObjects == false) {
      this.fetchingObjects = true;
      this.selectedObject.preferredPackagersText = this.preferredPackagersText;
      this.$lenderClient
        .addUpdateReturnOnlyID(this.selectedObject)
        .then((id) => {
          this.selectedObject.id = id;
          //this.selectedObject.userId = this.user.id;
          if (!existingSelection) {
            this.objects.push(this.selectedObject);
          }

          const orgIds = this.selectedBrokers.map((broker) => broker.id);

          this.currentPortalLinkSetting = this.selectedObject.usePortalUrl;

          return this.$lenderClient.updatePreferredOrgs(this.selectedObject.id, orgIds);
        })
        .finally(() => {
          this.editLenderName = false;
          this.fetchingObjects = false;
          this.updateRating = false;
          this.updatePreferredBrokers = false;
          this.error = "";
          this.editedLenderProductFamily = null;
          this.showEditProductNotesAndSnapshot = false;
          this.lenderForm.$setPristine();
        });
    } else {
      this.editLenderName = false;
      this.error = "";
      this.selectedObject = duplicateLender;
    }
  }

  updateObjects() {
    this.fetchingObjects = true;

    // Fetch all objects.
    this.$lenderClient
      .fetchAll()
      .then((response) => {
        this.objects = response as Lender[];
        if (this.filterType != "") {
          //TODO: need to fix this to use product type instead
          this.objects = this.objects.filter((lender) => {
            return lender.products.some((product) => {
              return product.lI_LoanFamily == Number(this.filterType);
            });
          });
        }

        if (!this.canSeeMultipleLenders && this.objects.length > 0) {
          //need to select first item as no ability to select
          this.selectObject(this.objects[0]);
        }
        this.preSelectedItem();
      })
      .finally(() => {
        this.fetchingObjects = false;
        this.editLenderName = false;
      });
  }

  delete() {
    if (this.fetchingObjects !== true) {
      this.fetchingObjects = true;
      this.$lenderClient
        .markAsDeleted(this.selectedObject.id)
        .then((response) => {
          if (response) {
            this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
            this.lenderForm.$setPristine();
            delete this.selectedObject;
          }
        })
        .finally(() => {
          this.fetchingObjects = false;
        });
    }
  }

  uploadProductFile(file, isSimulated) {
    this.dataLoading = true;
    let url =
      "/api/lender/importproducts?addLender=" +
      this.addLenders +
      "&updateLender=" +
      this.updateLenders +
      "&disableProducts=" +
      this.disableProducts +
      "&isSimulated=" +
      isSimulated;
    this.$uploadservice
      .upload({
        url: url,
        data: { file: file },
      })
      .then(
        (response) => {
          if (isSimulated) {
            this.simulatedResponse = response.data;
            this.showSimulatedResults = true;
          } else {
            this.updateObjects();
            this.showLenderUpload = false;
            this.showSimulatedResults = false;
            this.importFile = false;
          }
          this.dataLoading = false;
        },
        (response) => {
          // console.log('Error status: ' + resp.status);
        },
        (event) => {
          //            $scope.linkedInUploadProgress = 100.0 * parseFloat(evt.loaded) / parseFloat(evt.total);
          //          console.log('progress: ' + $scope.linkedInUploadProgress + '% ' + evt.config.data.file.name);
        },
      );
  }

  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }

  removeProduct(product: Product) {
    if (product.id > 0) {
      this.productClient.markAsDeleted(product.id).then((response) => {
        if (response) {
          this.selectedObject.products.splice(this.selectedObject.products.indexOf(product), 1);
          this.selectObject(this.selectedObject);
          this.lenderForm.$setPristine();
        }
      });
    } else {
      //never saved so just remove
      this.selectedObject.products.splice(this.selectedObject.products.indexOf(product), 1);
      this.selectedObjectProduct = null;
      this.selectObject(this.selectedObject);
      this.lenderForm.$setPristine();
    }
  }

  createProduct() {
    this.step = 1;
    this.selectedObjectProduct = {
      lenderId: this.selectedObject.id,
      lI_LoanProduct: ProductTypeEnum.Development, //.None value for LI_LoanProduct
      productRef: "",
      lenderGenericName: "",
      rates: [],
      lender: null,
      lI_LoanFamily: ProductFamilyEnum.None,
      lI_LoanType: LoanInvestmentTypeEnum.None,
      lI_Geography: LocationEnum.None,
      lI_Name: "",
      lI_Landline: "",
      lI_Mobile: "",
      lI_Email: "",
      lI_MinLoan: 0,
      lI_MaxLoan: 0,
      lI_Charge: ChargeTypeEnum.None,
      lI_CoFType: CofEnum.None,
      lI_CoF: 0,
      lI_Margin: 0,
      lI_Dev_TotRate: 0,
      lI_PGorCG: GuaranteeEnum.None,
      lI_PGorCGpercentage: 0,
      lI_PureResi: 0,
      lI_MixedUse: 0,
      lI_MixedUseCommPerc: 0,
      lI_PreLetPreSale: false,
      lI_HMO: 0,
      lI_Hotels: 0,
      lI_Leisure: 0,
      lI_LightIndus: 0,
      lI_HeavyIndus: 0,
      lI_CareHomes: 0,
      lI_Retirement: 0,
      lI_Medical: 0,
      lI_Student: 0,
      lI_Office: 0,
      lI_Retail: 0,
      lI_Educ: 0,
      lI_LandNoPlan: 0,
      lI_LandOutlinePlan: 0,
      lI_LandDetailedPlan: 0,
      lI_ClientIndiv: YesNoMaybe.NotfilledIn,
      lI_ClientCo: YesNoMaybe.NotfilledIn,
      lI_OverSeasClient: YesNoMaybe.NotfilledIn,
      lI_ClientOverseasCo: YesNoMaybe.NotfilledIn,
      lI_ShariaLoan: YesNoMaybe.NotfilledIn,
      lI_Syndication: YesNoMaybe.NotfilledIn,
      lI_Dev_MaxLTC: 0,
      lI_Dev_MaxLTGDV: 0,
      lI_Dev_MinRealEquity: 0,
      lI_Dev_SweatEquity: false,
      lI_Dev_ArrFeeIncBrokFee: 0,
      lI_Dev_ArrFeeBase: 0,
      lI_Dev_ExitFee: 0,
      lI_Dev_ExitFeeGDVOrGrossLoan: ExitFeeChargedOnEnum.None,
      lI_Dev_DeductArrFeeOrPaidSeparate: DeductorPayEnum.None,
      lI_Dev_AdminFee: false,
      lI_Dev_AdminFeeAmount: 0,
      lI_Dev_LenderLegalsDeductedFromLoan: false,
      lI_Dev_LegalFees: 0,
      lI_LegalFees_Type: LegalFeeTypeEnum.None,
      lI_Dev_QSDeductedFromLoan: false,
      lI_Dev_QSIntialFee: 0,
      lI_Dev_QSCostPerVisit: 0,
      lI_Dev_QSInitialFeePercOfWhat: QSChargesOfWhatEnum.None,
      lI_Dev_LenderValEst: 0,
      lI_LenderValuation_Type: ValuationFeeTypeEnum.None,
      lI_Dev_InterestAddedOrServiced: InterestServicedorRolledEnum.None,
      lI_Dev_MinTerm: 0,
      lI_Dev_MaxTerm: 0,
      lI_Dev_IncludeSDLT: false,
      lI_Dev_IncludeS106CIL: false,
      lI_Dev_IncludeAcquiLegalandEAFees: false,
      lI_Dev_IncludePlanningArchiClientQS: false,
      lI_Dev_IncludeLendInt: false,
      lI_Dev_IncludeArrFeeIncBrokFee: false,
      lI_Dev_IncludedLenderExitFee: false,
      lI_Dev_IncludeMkting: false,
      lI_Dev_IncludeEAFees: false,
      lI_Dev_IncludedOtherFees: false,
      lI_Dev_MaxNetLoanAgainstLandValue: 0,
      lI_Dev_MaxPoundperSqFtCap: 0,
      lI_Dev_CapOnIndivUnitVal: 0,
      lI_Dev_MezzPartners: "",
      lI_Dev_AllowMezz: false,
      lI_Dev_Contingency: false,
      lI_Dev_MinContingency: false,
      lI_Dev_MinContingencyPercent: 0,
      lI_Dev_MaxContingency: false,
      lI_Dev_MaxContingencyPercent: 0,
      lI_Dev_MinSalesPeriod: false,
      lI_Dev_MinSalesMonths: 0,
      lI_Dev_ProfFixedFees: 0,
      lI_Dev_Mez_Cof: CofEnum.None,
      lI_Dev_Mez_Margin: 0,
      lI_Dev_Mez_StartLTGDV: 0,
      lI_Dev_Mez_StartLTC: 0,
      lI_Dev_Mez_ProfShare: false,
      lI_Dev_Mez_ProfSharePerc: 0,
      lI_Dev_Mez_IntRate: 0,
      lI_Dev_Mez_ArrFeeIncBrokFee: 0,
      lI_Dev_Mez_QSCostPerVisit: 0,
      lI_Dev_Mez_Exit: 0,
      lI_Dev_Mez_LTGDV: 0,
      lI_Dev_Mez_LTC: 0,
      lI_Dev_Mez_MinEquity: 0,
      mez_ID: null,
      lenderName: "",
      lI_Part_Month_QS: 0,
      lI_Calc_Dev_Mez_LTC: 0,
      lI_Mezz_Legal_PercentOfGrossLoan: 0,
      lI_Mezz_Legal_PercentOfWhat: MezzLegalPercentOfWhatEnum.GrossLoan,
      lI_Mezz_Legal_FixedFee: 0,
      lI_Mezz_D1LLC: 0,
      isEnabled: true,
      additionalProductInfo: "",
      snapshot: "",
      willLendToFirstTimeDeveloper: YesNoMaybe.NotfilledIn,
      minNumberOfPreviousDevelopments: 0,
      depositRequiredPerc: 0,
      chargeOnProperty: YesNoMaybe.NotfilledIn,
      basisOfInterestRate: InterestRateBasis.None,
      isFixedRate: YesNoMaybe.NotfilledIn,
      isModular: YesNoMaybe.NotfilledIn,
      isAirRights: YesNoMaybe.NotfilledIn,
      isPermittedDevelopmentScheme: YesNoMaybe.NotfilledIn,
      isListedGradeOne: YesNoMaybe.NotfilledIn,
      isListedGradeTwo: YesNoMaybe.NotfilledIn,
      maxHouseSalesPrice: 0,
      maxFlatUnitPrice: 0,
      maxNumberOfUnits: 0,
      isWorkStarted: YesNoMaybe.NotfilledIn,
      lI_Dev_MaxPoundperSqFtCapFlats: 0,
      isReBridgeAllowed: YesNoMaybe.NotfilledIn,
      isServicedInterestAllowed: YesNoMaybe.NotfilledIn,
      isTitleInsuranceAllowed: YesNoMaybe.NotfilledIn,
      isIndemnityInsuranceAllowed: YesNoMaybe.NotfilledIn,
      isRetypedValuationAllowed: YesNoMaybe.NotfilledIn,
      lI_MinUnits: 0,
      lI_MaxUnitPrice: 0,
      lI_BulkMinUnits: null,
      lI_BulkMinAverageSalesPrice: null,
      lI_BulkLTV: 0,
      lI_BulkRate: 0,
      lI_LegalFeesFlatRate: 0,
      lI_ValuationFeesFlatRate: 0,
      maxRefurbLevel: RefurbishmentLevelEnum.None,
      minOwnershipPeriod: 0,
      maxIndividualUnitPrice: 0,
      minIndividualUnitPrice: 0,
      maxNumberOfBedrooms: 0,
      isTimberFrameConstruction: YesNoMaybe.NotfilledIn,
      isConcreteConstruction: YesNoMaybe.NotfilledIn,
      acceptableEPCRating: EPCRatingTypeEnum.None,
      ewS1AcceptableType: EWS1GradeTypeEnum.None,
      isInterestOnlyAllowed: YesNoMaybe.NotfilledIn,
      isCapitalAndRepaymentAllowed: YesNoMaybe.NotfilledIn,
      stressedAnnualRate: 0,
      stressedMonthlyRate: 0,
      monthlyRate: 0,
      allCommercialMixedUse: 0,
      mufb: 0,
      maxNumberOfMUFBUnits: 0,
      repaymentTypes: LoanRepaymentTypeEnum.None,
      fixedRateTerm: FixedRateTermEnum.None,
      minYearsLease: 0,
      individualICR: 0,
      companyICR: 0,
      tradingEntity: BorrowingEntityTypeEnum.None,
      minimumTradingPeriod: 0,
      arrangementFeeAdded: YesNoMaybe.NotfilledIn,
      maxAgeAtEndOfMortgageTerm: 0,
      maxAgeAtStartOfMortgageTerm: 0,
      postcodeInclusionList: "",
      postcodeExclusionList: "",
      isRegulated: false,
      isAdverseCreditAllowed: false,
      isBelowMarketValueAllowed: false,
      isAuctionPurchasesAllowed: false,
      valuationMethod: ValuationMethodEnum.None,
      nonPhysicalValuationType: NonPhysicalValuationEnum.None,
      offerSecondCharge: false,
      lastVerifiedDate: null,
      id: 0,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };
  }

  selectProduct(productId: number) {
    this.step = 1;
    this.productClient.fetch(productId).then((response) => {
      this.selectedObjectProduct = response;
      this.selectedObjectProduct.additionalProductInfo = this.convertPlainTextToHtml(
        this.selectedObjectProduct.additionalProductInfo,
      );
      this.maxLastVerifiedDate = response.lastVerifiedDate;
      //this.totalRate = this.selectedObjectProduct.lI_Dev_TotRate * 100;
      //     this.selectedLocations = this.selectedProduct.location.split(", ");
    });
  }

  saveProduct(product: Product) {
    this.productClient.isProductRefUnique(product.productRef, product.id).then((result) => {
      if (!result) {
        this.error = "Product Reference is not unique";
        return;
      }
      this.fetchingObject = true;
      // product.Location = this.selectedLocations.join(",");
      if (this.selectedObject.id) {
        // product.LI_Dev_TotRate = this.totalRate / 100;
        product.rates = product.rates ?? [];
        this.productClient
          .addUpdateReturnOnlyID(product)
          .then((response) => {
            product.id = response;
            this.fetchingObject = false;

            // Find the product in the selectedObject.Products list
            let existingProductIndex = this.selectedObject.products.findIndex((p) => p.id === product.id);

            if (existingProductIndex !== -1) {
              // Update the existing product if found
              this.selectedObject.products[existingProductIndex] = product;
            } else {
              // Otherwise, add the new product to the list
              this.selectedObject.products.push(product);
            }

            this.selectedObjectProduct = undefined;
          })
          .catch((response) => {
            this.fetchingObject = false;
          });
        if (!this.selectedObjectProduct.id) {
          this.selectedObject.products.push(this.selectedObjectProduct);
        }
      } else {
        this.fetchingObject = false;
        this.lenderForm.$setDirty();
      }
    });
  }

  duplicateProduct(product: Product, index: number, productRef: string = "") {
    let newProduct = {} as Product;
    (Object as any).assign(newProduct, product);

    delete newProduct.id;
    delete newProduct.lastUpdatedDateTime;
    delete newProduct.createdDateTime;
    delete newProduct.isEnabled;

    this.productClient.isProductRefUnique(productRef).then((result) => {
      //If producRef is not unique (or error) then do not duplicate product
      if (!result) {
        this.error = "Product Reference is not unique";
        return;
      }

      newProduct.productRef = productRef;

      this.selectedObject.products.splice(index, 0, newProduct);

      this.productClient.addUpdateReturnOnlyID(newProduct).then((result) => {
        this.selectedObject.products[index].id = result;
      });

      this.error = "";
      this.duplicateProductModal = false;
    });
  }

  sum(a: number, b: number): number {
    return a + b;
  }

  carriageReturnCheck(event) {
    if (event.key === "Enter") {
      this.selectedObjectProduct.additionalProductInfo += "\n";
    }
  }

  lenderKeyDown(event, field: string) {
    if (event.key === "Enter") {
      let position = event.target.selectionStart;
      if (this.selectedObject[field]) {
        this.selectedObject[field] = [
          this.selectedObject[field].slice(0, position),
          "\n",
          this.selectedObject[field].slice(position),
        ].join("");

        setTimeout(() => {
          event.target.setSelectionRange(position + 1, position + 1);
        }, 0);
      } else {
        this.preferredPackagersText = "\n";
      }
    }
  }

  updateCustomerServiceRating(star) {
    if (this.selectedObject.ratingCustomerService == 1 && star == 1) {
      this.selectedObject.ratingCustomerService = 0;
      this.updateRating = true;
    } else {
      this.selectedObject.ratingCustomerService = star;
      this.updateRating = true;
    }
  }

  updateSpeedRating(star) {
    if (this.selectedObject.ratingSpeed == 1 && star == 1) {
      this.selectedObject.ratingSpeed = 0;
      this.updateRating = true;
    } else {
      this.selectedObject.ratingSpeed = star;
      this.updateRating = true;
    }
  }

  updateFlexibilityRating(star) {
    if (this.selectedObject.ratingFlexibility == 1 && star == 1) {
      this.selectedObject.ratingFlexibility = 0;
      this.updateRating = true;
    } else {
      this.selectedObject.ratingFlexibility = star;
      this.updateRating = true;
    }
  }

  updateUserRating(star) {
    if (this.selectedObject.ratingUserRating == 1 && star == 1) {
      this.selectedObject.ratingUserRating = 0;
      this.updateRating = true;
    } else {
      this.selectedObject.ratingUserRating = star;
      this.updateRating = true;
    }
  }

  addClass(star: number, id: string) {
    let elementId = "";
    for (let i = 1; i <= star; i++) {
      elementId = id + i;
      document.getElementById(elementId).classList.add("selected");
    }
  }

  removeClass(star: number, id: string, rating) {
    let elementId = "";
    if (rating == undefined) {
      rating = 0;
    }
    for (let i = star; i > rating; i--) {
      elementId = id + i;
      document.getElementById(elementId).classList.remove("selected");
    }
  }

  removeLenderLogo() {
    this.selectedObject.logoURL = null;
    this.logoURL = null;
    this.lenderForm.$setDirty();
  }

  //calculateTotalRate() {
  //    this.totalRate = parseFloat(((this.selectedObjectProduct.lI_Margin * 100) + (this.selectedObjectProduct.lI_CoF * 100)).toFixed(2));
  //}

  totalRateValue() {
    return parseFloat(
      (this.selectedObjectProduct.lI_Margin * 100 + this.selectedObjectProduct.lI_CoF * 100).toFixed(2),
    );
  }

  selectLenderUser(lenderUser: ApplicationUser) {
    if (lenderUser) {
      this.selectedLenderUser = { ...lenderUser };
      this.initLenderUserProductType();

      this.isEditLenderUser = true;
    } else {
      this.selectedLenderUser = {} as ApplicationUser;
      this.isEditLenderUser = false;
    }

    this.showEditLenderUserModal = true;
  }

  isLenderUserEmpty() {
    for (let key in this.selectedLenderUser) {
      if (this.selectedLenderUser.hasOwnProperty(key) && key !== "$$hashKey") {
        return false;
      }
    }
    return true;
  }

  initLenderUserProductType() {
    if (!this.selectedLenderUser.lenderProductTypes) {
      this.selectedLenderUser.lenderProductTypes = 0;
    } else {
      for (let i = 1; i >= 0; i *= 2) {
        if (this.selectedLenderUser.lenderProductTypes >= i) {
          //number is in enum sum, add it to object
          if (this.selectedLenderUser.lenderProductTypes & i) {
            this.lenderUserProductType[i] = true;
          } else {
            this.lenderUserProductType[i] = false;
          }
        } else {
          return;
        }
      }
    }
  }

  updateLenderUserProductTypes(item: LenderProductTypeEnum) {
    this.selectedLenderUser.lenderProductTypes =
      this.selectedLenderUser.lenderProductTypes > 0 ? this.selectedLenderUser.lenderProductTypes : 0;

    if (item == LenderProductTypeEnum.All) {
      if (this.lenderUserProductType[item] == false) {
        this.selectedLenderUser.lenderProductTypes -= item;
      } else {
        this.lenderUserProductType.forEach((value, index) => {
          this.lenderUserProductType[index] = false;
        });

        this.selectedLenderUser.lenderProductTypes = 0;

        this.lenderUserProductType[item] = true;
        this.selectedLenderUser.lenderProductTypes += item;
      }
    } else {
      //if we are setting item to false and item exists, remove it, else add it
      if (this.lenderUserProductType[item] === true) {
        this.selectedLenderUser.lenderProductTypes += item;
      } else if (this.selectedLenderUser.lenderProductTypes > 0) {
        this.selectedLenderUser.lenderProductTypes -= item;
      }
    }
  }

  isLenderUserProductTypeEmpty() {
    if (this.lenderUserProductType.length === 0) return true;

    for (let i = 0; i < this.lenderUserProductType.length; i++) {
      let value = this.lenderUserProductType[i];
      if (value !== undefined && value !== null && value !== false) {
        return false;
      }
    }
    return true;
  }

  saveLenderUser() {
    var validUser = true;
    this.isSavingLenderUser = true;
    this.selectedLenderUser.lenderId = this.selectedObject.id;

    if (!this.selectedLenderUser.isLenderAdmin) {
      let lenderAdmin = this.assignedLenderUsers.find((l) => l.isLenderAdmin && l.id != this.selectedLenderUser.id);
      if (!lenderAdmin) {
        this.lendersavemessage = `Please ensure this lender has at least one admin user.`;
        this.isSavingLenderUser = false;
        validUser = false;
      }
    }

    if (validUser) {
      this.$lenderClient.saveLenderUser(!this.isEditLenderUser, this.selectedLenderUser).then((response) => {
        if (response) {
          this.isSavingLenderUser = false;
          this.isEditLenderUser = false;
          this.lenderUserProductType = [];
          this.showEditLenderUserModal = false;
        } else {
          if (this.isEditLenderUser) {
            this.lendersavemessage = `There is problem updating ${this.selectedLenderUser.fullName} details, Please try later.`;
          } else {
            this.lendersavemessage = `There is problem adding ${this.selectedLenderUser.fullName}, Please try later.`;
          }
        }
        this.fetchAssignedLenderUsers();
      });
    }
  }

  cancelEditLenderUserModal() {
    this.selectedLenderUser = undefined;
    this.lenderUserProductType = [];
    this.showEditLenderUserModal = false;
    this.error = "";
  }

  onClickOfMakeAdimn(lenderUser: ApplicationUser) {
    this.selectedLenderUser = lenderUser;
    this.displayMessage = `Are you sure you wish to make ${lenderUser.fullName} admin for this lender?`;
    this.confirmChangingLenderAdmin = true;
  }

  setLenderAsAdmin() {
    this.selectedLenderUser.isLenderAdmin = true;
    this.$lenderClient.setLenderAsAdmin(this.selectedLenderUser.id).then((response) => {
      if (response) {
        this.confirmChangingLenderAdmin = false;
      } else {
        this.lendersavemessage = `There is problem converting ${this.selectedLenderUser.fullName} to admin, Please try later`;
      }
      this.fetchAssignedLenderUsers();
    });
  }

  onClickOfDeleteLenderUser(lenderUser: ApplicationUser) {
    this.selectedLenderUser = lenderUser;
    let lenderAdmin = this.assignedLenderUsers.find((l) => l.isLenderAdmin && l.id != lenderUser.id);
    if (this.selectedLenderUser.isLenderAdmin && !lenderAdmin) {
      this.displayMessage = `Please assign a new Admin User before deleting ${lenderUser.fullName}.`;
    } else {
      this.displayMessage = `Are you sure you wish to remove ${lenderUser.fullName}?`;
      this.deleteLenderUserClicked = true;
    }
    this.confirmLenderAdminDeletion = true;
  }

  deleteLenderUser() {
    if (this.deleteLenderUserClicked) {
      this.$lenderClient.removeLenderUser(this.selectedLenderUser.id).then((response) => {
        this.fetchAssignedLenderUsers();
        this.confirmLenderAdminDeletion = false;
        this.deleteLenderUserClicked = false;
      });
    } else {
      this.confirmLenderAdminDeletion = false;
    }
  }

  closeLenderUserDeleteModal() {
    this.confirmChangingLenderAdmin = false;
    this.confirmLenderAdminDeletion = false;
    this.deleteLenderUserClicked = false;
    this.lendersavemessage = "";
  }

  onIsLenderAdminChange() {
    if (!this.selectedLenderUser.isLenderAdmin && this.isEditLenderUser) {
      let selectedUserFrom = this.assignedLenderUsers.find((l) => l.id == this.selectedLenderUser.id);
      let lenderAdmin = this.assignedLenderUsers.find((l) => l.isLenderAdmin && l.id != this.selectedLenderUser.id);
      if (selectedUserFrom?.isLenderAdmin && !lenderAdmin) {
        this.error = `Please assign a new Admin User.`;
      }
    } else if (this.selectedLenderUser.isLenderAdmin) {
      this.error = "";
    }
  }

  lenderUserChanged() {
    this.initLenderUserProductType();
  }

  getProductName(key: number): string {
    let names: string[] = [];
    let totalKey = 0;

    for (let item of this.productTypeOptions) {
      if ((key & item.key) === item.key && item.key !== 0) {
        names.push(item.displayName);
        totalKey |= item.key;
      }
    }

    if (totalKey === ProductTypeEnum.Bridging) {
      return "Bridging";
    }

    return names.join(", ");
  }

  onFamilyChange(): void {
    this.filteredProductTypeOptions = this.productTypeOptions.filter((item) => {
      return this.productTypeBelongToFamily(item);
    });

    switch (this.selectedObjectProduct.lI_LoanFamily) {
      case ProductFamilyEnum.Bridging:
        this.selectedObjectProduct.lI_LoanProduct &= ProductTypeEnum.Bridging;
        break;
      case ProductFamilyEnum.Development:
        this.selectedObjectProduct.lI_LoanProduct &= ProductTypeEnum.Development;
        break;
      case ProductFamilyEnum.Commercial:
        this.selectedObjectProduct.lI_LoanProduct &= ProductTypeEnum.CommercialAll;
        break;
      case ProductFamilyEnum.None:
        this.selectedObjectProduct.lI_LoanProduct &= ProductTypeEnum.None;
        break;
      default:
        break;
    }

    if (this.selectedObjectProduct.lI_LoanProduct === 0 || isNaN(this.selectedObjectProduct.lI_LoanProduct)) {
      this.selectedObjectProduct.lI_LoanProduct = null;
    }
  }

  productTypeBelongToFamily(item): boolean {
    switch (this.selectedObjectProduct.lI_LoanFamily) {
      case ProductFamilyEnum.Development:
        return (item.key & ProductTypeEnum.Development) !== 0;
      case ProductFamilyEnum.Bridging:
        return (item.key & ProductTypeEnum.Bridging) !== 0;
      case ProductFamilyEnum.Commercial:
        return (item.key & ProductTypeEnum.CommercialAll) !== 0;
      default:
        return false;
    }
  }

  productIsValid(): boolean {
    const forms = [
      this.multiPartForm1,
      this.multiPartForm2,
      this.multiPartForm3,
      this.multiPartForm4,
      this.multiPartForm5,
      this.multiPartForm6,
      this.multiPartForm7,
    ];

    var productError;

    if (
      this.selectedObjectProduct.lI_LoanFamily == ProductFamilyEnum.Commercial ||
      (this.selectedObjectProduct.lI_LoanFamily &&
        (this.selectedObjectProduct.lI_LoanProduct & ProductTypeEnum.BridgingPreconstruction ||
          this.selectedObjectProduct.lI_LoanProduct & ProductTypeEnum.BridgingDeveloperExit ||
          this.selectedObjectProduct.lI_LoanProduct & ProductTypeEnum.BridgingPurchaseOrRefinance))
    ) {
      this.error = null;
      return true;
    }

    if (
      (this.multiPartForm6 && this.multiPartForm6.$dirty && !this.selectedObjectProduct.lI_Dev_ArrFeeIncBrokFee) ||
      Number(this.selectedObjectProduct.lI_Dev_ArrFeeIncBrokFee) <= 0
    ) {
      productError = this.error = "Arrangement Fee total % must be greater than 0";
    } else {
      this.error = null;
    }

    return productError == null;
  }

  validateSelection() {
    this.isValidSelection = this.selectedBrokers.length <= 3;
    this.updatePreferredBrokers = true;
  }

  getSelectedBrokersString() {
    if (this.selectedBrokers == null || this.selectedBrokers.length == 0) {
      return "";
    }
    return this.selectedBrokers
      .map(function (item) {
        return item.name;
      })
      .join(", ");
  }

  getPreferredOrgs(): void {
    this.selectedBrokers = [];
    this.$lenderClient
      .getSelectedLenderPreferredOrgs(this.selectedObject.id)
      .then((response) => {
        return response.map((x) => x.id);
      })
      .then((ids) => {
        this.organisations.forEach((org: Organisation) => {
          (org as any).ticked = false;
          ids.forEach((id: number) => {
            if (org.id == id) {
              this.selectedBrokers.push(org);
              (org as any).ticked = true;
            }
          });
        });
      });
  }

  trustedHtml(plainText) {
    return this.$sce.trustAsHtml(plainText);
  }

  validatePortalLink() {
    if (this.selectedObject.portalUrl) {
      let url = this.selectedObject.portalUrl;
      if (!/^https?:\/\//i.test(url)) {
        url = "http://" + url;
      }
      window.open(url, "_blank");
    }
  }

  /**
   * Display a modal to edit details that are specific at a product family level
   * @param productFamily
   */
  showEditLenderProductFamilyModal(productFamily: ProductFamilyEnum) {
    this.tempSelectedObject = { ...this.selectedObject };
    this.editedLenderProductFamily = productFamily;
    this.showEditProductNotesAndSnapshot = true;
  }

  /** Close the lender's product family edit modal and cancel/undo changes */
  cancelEditLenderProductFamilyModal() {
    this.selectedObject = this.tempSelectedObject;
    this.editedLenderProductFamily = null;
    this.showEditProductNotesAndSnapshot = false;
    this.error = "";
  }

  getSubscriptionTypeDisplayName(value: LenderSubscriptionTypeEnum): string {
    const option = this.subscriptionTypeOptions.find((item) => item.key === value);
    return option ? option.displayName : "None Selected";
  }

  getLenderRelationsAccountManager() {
    this.staticDataClient.getLenderRelationsAccountManager().then((response) => {
      this.accountManagersOptions = response.split(",");
    });
  }

  convertPlainTextToHtml(content: string): string {
    if (!content) return "";

    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(content);

    if (hasHtmlTags) {
      return content;
    }

    // Convert plain text newlines into <p> blocks
    const paragraphs = content
      .split(/\n+/)
      .map((line) => `<p>${line.trim()}</p>`)
      .join("");

    return paragraphs;
  }

  closeLenderUploadModal() {
    this.showLenderUpload = false;
    this.showSimulatedResults = false;
    this.simulatedResponse = null;
    this.importFile = null;
  }
}
